import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Input, InputLabel } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const RescuersNumber = ({
  value,
  handleClick,
  showLabel = false,
  isMobile = false,
  inputId = 'numrescuers-helper',
}) => {
  const handleRescuerNumberClick = (event) =>
    handleClick({
      event,
      value: value + 1,
    });

  return (
    <FormControl
      variant="standard"
      sx={{ maxWidth: 166 }}
      onClick={(event) => (isMobile ? handleRescuerNumberClick(event) : null)}
    >
      {showLabel && (
        <InputLabel htmlFor={inputId} shrink>
          # of Rescuers needed:
        </InputLabel>
      )}
      <Input
        id={inputId}
        readOnly
        sx={{ textAlign: 'center' }}
        value={value}
        endAdornment={
          <IconButton
            color="primary"
            size="small"
            aria-label="add rescuer"
            onClick={(event) => (isMobile ? null : handleRescuerNumberClick(event))}
          >
            <AddCircleOutlineIcon fontSize="small" />
          </IconButton>
        }
      />
    </FormControl>
  );
};

RescuersNumber.propTypes = {
  showLabel: PropTypes.bool,
  isMobile: PropTypes.bool,
  inputId: PropTypes.string,
};

export default RescuersNumber;
